import {gsap, Power2} from 'gsap'


export function setupExploreSlider(scroller, locoScroll) {

  let exploreSlider = $('.js-explore-slider')

  if (exploreSlider.length) {
    let curSlideC = exploreSlider.find('.js-current-slide')
    let prevButton = exploreSlider.find('.js-prev-slide')
    let nextButton = exploreSlider.find('.js-next-slide')
    let slideSelect = exploreSlider.find('.js-explore-select')

    let totalSlides = exploreSlider.data('total-slides')
    let curSlide = 0;
    let nextSlide = 1;
    let moveDirectionNext = 1
    let selectFlag = 0

    // scroll animation
    let container = '.js-explore-slider'
    let elements = $(`${container} .js-slide-content`)
    let elementsCount = elements.length - 1
    let slideLength = 500


    nextButton.click(function () {
      nextSlide = curSlide + 1
      if (nextSlide > totalSlides) nextSlide = 0
      moveDirectionNext = 1
      goToNextSlide()
    })
    prevButton.click(function () {
      nextSlide = curSlide - 1
      if (nextSlide < 0) nextSlide = totalSlides
      moveDirectionNext = 0
      goToNextSlide()
    })
    slideSelect.change(function () {
      nextSlide = parseInt($(this).val())
      if (nextSlide !== curSlide && !selectFlag) {
        goToNextSlide()
      }
    })

    function goToNextSlide () {
      if (window.innerWidth > 1200 && 1 === 0) {
        let scrollTo = nextSlide * slideLength
        locoScroll.scrollTo('#explore',
          {
            'offset': scrollTo,
            'duration': 1000,
            'disableLerp': true,
          })

      } else {

        let curSlideContent = $('.js-slide-content-' + curSlide)
        let nextSlideContent = $('.js-slide-content-' + nextSlide)
        let curSlideContentChilds = curSlideContent.children()
        let nextSlideContentChilds = nextSlideContent.children()

        // set current slide
        curSlideC.html(zeroPad(nextSlide + 1, 2))
        selectFlag = 1
        slideSelect.val(nextSlide).change()
        selectFlag = 0

        // change text animations
        let moveTo = '-6rem'
        let moveSet = '6rem'
        let callNextContent = "<0.1"
        if (window.innerWidth < 1200) callNextContent = ">0"
        if (!moveDirectionNext) {
          moveTo = '6rem'
          moveSet = '-6rem'
          jQuery.fn.reverse = [].reverse
          curSlideContentChilds.reverse()
          nextSlideContentChilds.reverse()
        }

        let slideOut = gsap.timeline({ onComplete: () => curSlideContent.css('display', 'none') })
        let slideIn = gsap.timeline({})

        curSlideContentChilds.each(function (i) {
          slideOut.set(this, { opacity: 1, top: '0' })
        })
        curSlideContentChilds.each(function (i) {
          slideOut.to(this, { opacity: 0, top: moveTo, duration: 0.6, ease: "ease" }, "<0.1")
        })
        slideOut.call(slideInNextContent, null, callNextContent)

        function slideInNextContent () {
          nextSlideContentChilds.each(function (i) {
            slideIn.set(this, { opacity: 0, top: moveSet })
          })
          nextSlideContentChilds.each(function (i) {
            slideIn.to(this, { opacity: 1, top: '0', duration: 0.6, ease: "ease" }, "<0.1")
          })
          nextSlideContent.css('display', 'block')
        }

        // change image animations
        if (moveDirectionNext) {
          gsap.to('.js-slide-img-' + curSlide, { x: 0, y: '-100%', ease: 'ease', duration: 0.8, delay: 0 })
          gsap.to('.js-slide-img-' + curSlide + ' .img', { scale: 1.2, duration: 0.8, ease: 'power3' })
          gsap.to('.js-slide-img-' + curSlide + ' .img', { x: 0, y: '60%', duration: 0.8, ease: 'ease' })

          gsap.set('.js-slide-img-' + nextSlide, { x: 0, y: '100%' })
          gsap.set('.js-slide-img-' + nextSlide + ' .img', { y: '-60%', scale: 1.2 })
        } else {
          gsap.to('.js-slide-img-' + curSlide, { x: 0, y: '100%', ease: 'ease', duration: 0.8, delay: 0 })
          gsap.to('.js-slide-img-' + curSlide + ' .img', { scale: 1.2, duration: 0.8, ease: 'power3' })
          gsap.to('.js-slide-img-' + curSlide + ' .img', { x: 0, y: '-60%', duration: 0.8, ease: 'ease' })

          gsap.set('.js-slide-img-' + nextSlide, { x: 0, y: '-100%' })
          gsap.set('.js-slide-img-' + nextSlide + ' .img', { y: '60%', scale: 1.2 })
        }

        gsap.to('.js-slide-img-' + nextSlide, { x: 0, y: 0, duration: 0.8, ease: 'ease' })
        gsap.to('.js-slide-img-' + nextSlide + ' .img', { x: 0, y: 0, duration: 0.8, ease: 'ease' })
        gsap.to('.js-slide-img-' + nextSlide + ' .img', { scale: 1, duration: 0.8, ease: 'power.in' })

        // set new current slide
        curSlide = nextSlide

      }

    }

    if (window.innerWidth > 1200 && 1 === 0) {

      let sliderTimeline = gsap.timeline({
        ease: Power2.easeIn,
        scrollTrigger: {
          trigger: container,
          pin: true,
          end: `${elementsCount * slideLength}`,
          scrub: true,
          scroller: scroller,
          //snap: 1 / elementsCount,
          //markers: true,
        },
      })

      elements.each(function (i) {
        let iSlide = i
        let nextSlide = i + 1

        if (nextSlide < elements.length) {
          sliderTimeline.addLabel('slide-' + i)

          // image animation
          sliderTimeline.to('.js-slide-img-' + iSlide, { x: 0, y: '-100%', ease: 'ease', duration: 2 })
          sliderTimeline.to('.js-slide-img-' + iSlide + ' .img', { scale: 1.2, duration: 2, ease: 'power3' }, '<')
          sliderTimeline.to('.js-slide-img-' + iSlide + ' .img', { x: 0, y: '60%', duration: 2, ease: 'ease' }, '<')

          sliderTimeline.set('.js-slide-img-' + nextSlide, { x: 0, y: '100%' }, '<')
          sliderTimeline.set('.js-slide-img-' + nextSlide + ' .img', { y: '-60%', scale: 1.2 }, '<')

          sliderTimeline.to('.js-slide-img-' + nextSlide, { x: 0, y: 0, duration: 2, ease: 'ease' }, '<')
          sliderTimeline.to('.js-slide-img-' + nextSlide + ' .img', { x: 0, y: 0, duration: 2, ease: 'ease' }, '<')
          sliderTimeline.to('.js-slide-img-' + nextSlide + ' .img', { scale: 1, duration: 2, ease: 'power.in' }, '<')

          // text animation
          let curSlideContent = $('.js-slide-content-' + iSlide)
          let nextSlideContent = $('.js-slide-content-' + nextSlide)
          let curSlideContentChilds = curSlideContent.children()
          let nextSlideContentChilds = nextSlideContent.children()

          // text change animations
          curSlideContentChilds.each(function (i) {
            sliderTimeline.set(this, { opacity: 1, top: '0' }, '<')
          })
          nextSlideContentChilds.each(function (i) {
            sliderTimeline.set(this, { opacity: 0, top: '6rem' }, '<')
          })

          curSlideContentChilds.each(function (i) {
            sliderTimeline.to(this, { opacity: 0, top: '-6rem', duration: 1, ease: "ease" }, "<0.1")
          })

          sliderTimeline.set(nextSlideContent, { display: 'block' }, '<0.2')
          nextSlideContentChilds.each(function (i) {
            sliderTimeline.to(this, { opacity: 1, top: '0rem', duration: 1, ease: "ease" }, "<0.4")
          })

          sliderTimeline.set(curSlideContent, { display: 'none' })

          // set current slide and dropdown
          sliderTimeline.call(function () {
            let prevSlide = iSlide
            if (prevSlide < 0) prevSlide = elements.length - 1
            let next = sliderTimeline.scrollTrigger.direction === 1 ? nextSlide : prevSlide
            curSlideC.html(zeroPad(next + 1, 2))

            selectFlag = 1
            slideSelect.val(next).change()
            selectFlag = 0

            curSlide = next

          }, null, 'slide-' + i + '+=1.5')

        }
      })

    } // end desktop scrolltrigger logic

  }

}

const zeroPad = (num, places) => String(num).padStart(places, '0')
